(function (angular) {
    'use strict';

    angular.module("branchReports")
        .controller("ReportsMessagingCtrl", [
            "$scope", "$timeout", "$state", 'channelsData', "channelsProvider", function ($scope, $timeout, $state, channelsData, channelsProvider) {

                $scope.fromOptions = {
                    showWeeks: false
                };

                $scope.toOptions = {
                    showWeeks: false
                };

                $scope.channels = [
                    {
                        id: 'all',
                        label: 'All',
                        configured: true,
                        state: 'main.apiSpace.reports.messaging.channels'
                    },
                    {
                        id: 'sms',
                        label: channelsProvider.sms.name,
                        configured: true,
                        state: 'main.apiSpace.reports.messaging.channel'
                    },
                    {
                        id: 'fbMessenger',
                        label: channelsProvider.fbMessenger.name,
                        configured: false,
                        state: 'main.apiSpace.reports.messaging.channel'
                    },
                    {
                        id: 'email',
                        label: channelsProvider.email.name,
                        configured: false,
                        state: 'main.apiSpace.reports.messaging.channel'
                    },
                    {
                        id: 'appMessaging',
                        label: 'App Messaging',
                        configured: false,
                        state: 'main.apiSpace.reports.messaging.channel'
                    },
                    {
                        id: 'twitterDm',
                        label: channelsProvider.twitterDm.name,
                        configured: false,
                        state: 'main.apiSpace.reports.messaging.channel'
                    },
                    {
                        id: 'whatsApp',
                        label: channelsProvider.whatsApp.name,
                        configured: false,
                        state: 'main.apiSpace.reports.messaging.channel'
                    },
                    {
                        id: 'rcs',
                        label: channelsProvider.rcs.name,
                        configured: false,
                        state: 'main.apiSpace.reports.messaging.channel'
                    }
                ];

                // filtering channels and disable not configured ones

                filterChannelData();

                $scope.go = function go(arg, param) {
                    $state.go(arg, { channel: param });
                };

                $scope.getCurrentState = function getCurrentState() {
                    if ($state.params.channel) {
                        return _.find($scope.channels, function (o) { return $state.params.channel == o.id; }).label;
                    } else {
                        return 'All';
                    }

                };

                $scope.open = function ($event, toOpen) {
                    $event.preventDefault();
                    $event.stopPropagation();
                    toOpen.opened = !toOpen.opened;
                };

                $scope.calendar = {
                    from: {},
                    to: {}
                };

                $scope.query = {
                    from: {
                    },
                    to: {
                    },
                    system: 'all'
                };

                $scope.dateRangeChange = function onDateRangeChange() {
                    $scope.$broadcast('reports:channels:dateRangeChange', $scope.query);
                };

                var _selectedDateRange = "7Days";
                Object.defineProperty($scope, 'selectedDateRange', {
                    get: function () {
                        return _selectedDateRange;
                    },
                    set: function (date) {
                        _selectedDateRange = date;
                        switch (date) {
                            case "Today":
                                $scope.query.to.value = moment().startOf('day').toDate();
                                $scope.query.from.value = moment().endOf('day').toDate();
                                $scope.dateRangeChange();
                                break;
                            case "7Days":
                                $scope.query.from.value = moment().startOf('week').toDate();
                                $scope.query.to.value = moment().endOf('week').toDate();
                                $scope.dateRangeChange();
                                break;
                            case "30Days":
                                $scope.query.from.value = moment().startOf('month').toDate();
                                $scope.query.to.value = moment().endOf('month').toDate();
                                $scope.dateRangeChange();
                                break;
                            case "clear":
                                $scope.query.to.value = moment().endOf('day').toDate();
                                $scope.query.from.value = null;
                                $scope.dateRangeChange();
                                break;
                        }
                    }
                });
                $scope.selectedDateRange = "7Days";
                $timeout($scope.dateRangeChange(), 0);

                $scope.$on('reports:channels:stateChange',
                    function (e, message) {
                        $scope.query = message;
                        if (moment(message.from.value).isSame(moment().startOf('month'), 'day')) {
                            $scope.selectedDateRange = "30Days";
                        }
                        else if (moment(message.from.value).isSame(moment().startOf('week'), 'day')) {
                            $scope.selectedDateRange = "7Days";
                        }
                        else if (moment(message.from.value).isSame(moment(), 'day')) {
                            $scope.selectedDateRange = "Today";
                        } else {
                            $scope.selectedDateRange = undefined;
                        }

                    }
                );

                function filterChannelData() {
                    channelsData.forEach(function (channel) {
                        var configuredChannel = _.find($scope.channels, function (o) {
                            return channel.id == o.id;
                        });

                        if (configuredChannel) {
                            configuredChannel.configured = true;

                        } else {
                            $scope.channels.push({
                                id: channel.id,
                                label: channel.name,
                                configured: true,
                                state: 'main.apiSpace.reports.messaging.channel'
                            });
                        }

                    });
                }

            }
        ]);

})(window.angular);

